'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner";

import Alert from 'react-bootstrap/Alert';

import appStore from './AppStore';
import {States} from "./AppConstants";
import BackdoorStore from "./BackdoorStore";
import Loader from "./Loader";

class Backdoor extends Component {

    constructor(props) {
        super(props);
        this.backdoorInput = React.createRef();
        // Don't initialize state based on props.
        this.state = {
            showModal: false,
        };

        this.store = new BackdoorStore();

        // Bind this to click handlers.
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.submit = this.submit.bind(this);
        this.updateFormValue = this.updateFormValue.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onEntered = this.onEntered.bind(this);
    }

    onEntered = () => this.backdoorInput.current.focus();

    submit = async() => {
        if (!this.isPending()) {
            this.store.submitBackdoor();
        }
    }

    updateFormValue(e) {
        e.stopPropagation();
        let value = e.target.value;
        this.store.updateFormValue(value);
        this.store.clearError();
    }


    handleKeyUp = (event) => {
        if (event.key === 'Enter') this.submit()
    };

    close = () => this.setState({ showModal: false });
    open = () => this.setState({ showModal: true });

    isPending = () => this.store.state === States.pending;

    _buildComponent() {
        let errorMessage = this.store.errorMessage ? <Alert variant="danger">{this.store.errorMessage}</Alert> : null;

        const OpenComponent = this.props.openComponent;
        let isButtonOpenComponent = OpenComponent.hasOwnProperty("displayName") && OpenComponent.displayName === "Button";

        return (
            <>
                <OpenComponent variant={isButtonOpenComponent ? "inline-link":undefined} onClick={this.open}>Backdoor</OpenComponent>
                <Modal id="modal-backdoor"
                       show={this.state.showModal}
                       onHide={this.close}
                       size="sm"
                       autoFocus={false}
                       onEntered={this.onEntered}
                       aria-labelledby="modal-backdoor-title"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-backdoor-title">Backdoor</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Loader show={this.store.state === States.pending}>
                            <Form.Group id="backdoorNetId">
                                <Form.Label>NetID</Form.Label>
                                <Form.Control
                                    name="backdoor"
                                    type="text"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck="false"
                                    placeholder={appStore.getUserName()}
                                    onChange={this.updateFormValue}
                                    onKeyUp={this.handleKeyUp}
                                    ref={this.backdoorInput} />
                            </Form.Group>
                            {errorMessage}
                        </Loader>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.submit} disabled={this.isPending()} variant="primary">Submit</Button>
                        <Button onClick={this.close} variant="link">Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    render() {
        return this._buildComponent();
    }
}

Backdoor.propTypes = {
    openComponent: PropTypes.elementType
};

Backdoor.defaultProps = {
    openComponent: Button
};

export default observer(Backdoor);
